import { Component, OnInit } from "@angular/core";
import { StorafeUtil } from "../../../shared/util/storasge.util";
import { CODIGO_CENTRUS } from "../../../../app.constants";

@Component({
    selector: "app-pbdc-dashboard",
    templateUrl: "./pbdc-dashboard.component.html",
    styleUrls: ["./pbdc-dashboard.component.css"],
})
export class PbdcDashboardComponent implements OnInit {
    constructor() {}

    param = "/cardMenus/cardMenuPlanos";

    ngOnInit() {}

    getDadosSesseionStorage(): Promise<string> {
        return new Promise((resolve, reject) => {
            const recuperandoObjeto =
                StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
            resolve(recuperandoObjeto);
        });
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-dashboard/pbdc-dashboard.component.ts